import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MdAddCircleOutline, MdDeleteForever, MdEdit } from 'react-icons/md';
import { toast } from 'react-toastify';
import Collapse, { Panel } from 'rc-collapse';
import { useSelector } from 'react-redux';
import { Container, PanelItem, Answer } from './styles';
import api from '~/services/api';

export default function FAQList() {
  const [faq, setFaq] = useState([]);
  const [open, setOpen] = useState([]);

  const isAdmin = useSelector(state => state.user.profile.isAdmin);
  const handleDelete = async item => {
    await api.delete(`/faq/${item.id}`);
    const newArray = faq.filter(faqObj => faqObj.id !== item.id);
    setFaq(newArray);
    toast.error(`Question '${item.question}' was deleted.`);
  };
  useEffect(() => {
    async function loadFaqs() {
      try {
        const response = await api.get('/faq');
        setFaq(response.data);
      } catch (err) {
        toast.error('Error fetching the FAQ, try it later');
      }
    }
    loadFaqs();
  }, []);
  return (
    <Container>
      {isAdmin && (
        <header>
          <Link to="/faq/edit">
            <MdAddCircleOutline color="#FFF" size={22} />
            New FAQ
          </Link>
        </header>
      )}

      <Collapse
        className="collapse"
        accordion
        onChange={activeKey => {
          setOpen(activeKey);
        }}
        activeKey={open}
      >
        {faq.map(item => {
          return (
            <Panel
              className="panel"
              key={item.id}
              header={
                <PanelItem>
                  <p>{item.question}</p>
                  {isAdmin && (
                    <div>
                      <Link to={{ pathname: '/faq/edit', state: { item } }}>
                        <MdEdit color="#666" size={24} />
                      </Link>
                      <button type="button" onClick={() => handleDelete(item)}>
                        <MdDeleteForever color="#CA0B00" size={24} />
                      </button>
                    </div>
                  )}
                </PanelItem>
              }
            >
              <Answer>{item.answer}</Answer>
            </Panel>
          );
        })}
      </Collapse>
    </Container>
  );
}
